import React, { useState } from 'react';
import Header from '../component/Header';
import Sidebar from '../component/Sidebar';
import CreateIcon from '@mui/icons-material/Create';
import PersonalInfo from '../component/PersonalInfo';
import Subscription from '../component/Subscription';
import ChangePassword from '../component/ChangePassword';
import EditProfileModal from '../component/EditProfileModal';

const Settings = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isPersonalInfoVisible, setIsPersonalInfoVisible] = useState(true);
    const [isSubscriptionVisible, setIsSubscriptionVisible] = useState(false);
    const [isChangePasswordVisible, setIsChangePasswordVisible] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const togglePersonalInfo = () => {
        setIsPersonalInfoVisible(true);
        setIsSubscriptionVisible(false);
        setIsChangePasswordVisible(false);
    };

    const toggleSubscription = () => {
        setIsPersonalInfoVisible(false);
        setIsSubscriptionVisible(true);
        setIsChangePasswordVisible(false);
    };

    const toggleChangePassword = () => {
        setIsPersonalInfoVisible(false);
        setIsSubscriptionVisible(false);
        setIsChangePasswordVisible(true);
    };

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
         <div className='w-full flex items-start justify-center bg-[#F9FAFB] relative'>
            <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block w-full lg:w-1/6 fixed left-0 top-0 h-full z-50`}>
                <Sidebar toggleSidebar={toggleSidebar} />
            </div>

            {isSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={toggleSidebar}
                    toggleSidebar={toggleSidebar} 
                    isSidebarOpen={isSidebarOpen}
                ></div>
            )}


            <div className='flex flex-col w-full space-y-4 lg:ml-[16.67%]'>
                <div>
                     <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} 
                     title='Settings'
                     />  
                </div>

                <div className='w-full p-4 lg:p-[30px] instrument-sans-medium'>
                    <div className='w-full flex items-center justify-between '>
                        <div className='flex gap-3 text-sm items-center md:text-base lg:gap-6'>
                            <button onClick={togglePersonalInfo} className={isPersonalInfoVisible ? 'text-[#069125] pb-1 border-b border-[#069125] font-medium' : ''}>
                                Personal Info
                            </button>
                        </div>

                        <div>
                            {isPersonalInfoVisible && (
                                <button onClick={openModal} className='flex gap-1 bg-[#069125] text-white font-medium py-1 px-2 items-center rounded-md text-sm md:text-base md:py-2 md:px-4'>
                                    <CreateIcon className=''/>
                                    <span>Edit Profile</span>
                                </button>
                            )}

                            {isSubscriptionVisible && (
                                <button className='flex gap-1 bg-[#069125] text-white font-medium py-1 px-2 items-center rounded-md text-sm md:text-base md:py-2 md:px-4'>
                                    <span>Fund Wallet</span>
                                </button>
                            )}
                        </div>
                    </div>

                    {isPersonalInfoVisible && (
                        <div>
                            <PersonalInfo />
                        </div>
                    )}

                </div>
            </div>

            <EditProfileModal isOpen={isModalOpen} onClose={closeModal} />
       </div>
    );
};

export default Settings;
